import { ShipmentZonesApi } from '../api/ShipmentZonesApi'
import { ShipmentZones } from '../core/ShipmentZones'

import { shipmentZonesStore } from '../store/shipmentZonesStore'
import { subscriptionStore } from '../store/subscriptionStore'
import { deliveryStore } from '../store/deliveryStore'
import { orderStore } from '../store/orderStore'
import { Repository } from '../services/Repository'

import { dates } from './dates'

export const deliveryContainer = {
    data () {
        return {
            shipmentZonesStore: shipmentZonesStore.state,
            subscriptionStore: subscriptionStore.state,
            deliveryStore: deliveryStore.state,
            orderStore: orderStore.state
        }
    },
    mixins: [
        dates
    ],

    computed: {
        user () {
            return this.$root.user
        },

        delivery () {
            return this.deliveryStore
                && this.deliveryStore.deliveries.order.find(r => +r.attributes.target_id === +this.orderStore.order.id)
                && this.deliveryStore.deliveries.order.find(r => +r.attributes.target_id === +this.orderStore.order.id).attributes
        },
    },

    methods: {
        getCurrentLoadedDeliveryByOrderState() {
            return deliveryStore.state.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id)
        },
        $_deliveryContainer_fillSubscriptionParams () {



            if (this.getCurrentLoadedDeliveryByOrderState()) {
                //alert('ya');
                return Promise.resolve()
            }


            return this.loadDeliveryAndTimeRange()

            .then(response => {
                return this.$_deliveryContainer_fillParams()
            })

            .then(response => {
                return this.$_deliveryContainer_loadDeliveries()
            })

            .then(response => {
                this.loadTimeRangeFromDelivery();
            })
            
        },

        $_deliveryContainer_fillParams () {
            var sub = this.subscriptionStore.subscription

            var delivery = this.getCurrentLoadedDeliveryByOrderState()

            var address
            if (delivery) {
                address = this.deliveryStore.address.delivery.find(r => +r.id === +delivery.attributes.address_id)
            }

            if (!address || !delivery) return Promise.resolve()

            address = address.attributes
            delivery = delivery.attributes

            subscriptionStore.updateSubscriptionParam({ param: 'province', value: address.province })
            subscriptionStore.updateSubscriptionParam({ param: 'zip_code', value: address.zip_code })
            subscriptionStore.updateSubscriptionParam({ param: 'country', value: address.country })
            subscriptionStore.updateSubscriptionParam({ param: 'point_name', value: address.name })
            subscriptionStore.updateSubscriptionParam({ param: 'street', value: address.street })
            subscriptionStore.updateSubscriptionParam({ param: 'city', value: address.city })
            subscriptionStore.updateSubscriptionParam({ param: 'latitude', value: address.latitude })
            subscriptionStore.updateSubscriptionParam({ param: 'longitude', value: address.longitude })
            subscriptionStore.updateSubscriptionParam({ param: 'telephone', value: delivery.phone })
            subscriptionStore.updateSubscriptionParam({ param: 'message', value: delivery.notes })
            subscriptionStore.updateSubscriptionParam({ param: 'name', value: delivery.name })
            subscriptionStore.updateSubscriptionParam({ param: 'code', value: delivery.code })

            return Promise.resolve()
        },

        loadTimeRangeFromDelivery() {

          let timeRange = new Repository().getCurrentDeliveryTimeRange();

            if (timeRange) {

                deliveryStore.updateTimeRangesParam({ start: timeRange.attributes.start })
                deliveryStore.updateTimeRangesParam({ end: timeRange.attributes.end })
            }
        },
        loadDeliveryAndTimeRange () {
            if (!this.user || !this.orderStore.order) return Promise.resolve()

                return deliveryStore.getDelivery({ 
                    target_type: 'order', 
                    target_id: this.orderStore.order.id,
                    include: 'timeRanges,address,shipment_zone.courier'
                })

            .then(response => {

                this.loadTimeRangeFromDelivery()

                if (response && response.body.included) {

                    let courier = response.body.included.find(record => record.type === 'courier')
                    subscriptionStore.updateShipmentCourier(courier.attributes.name)

                    var record = response.body.included.find(record => record.type === 'address')
                    if (record) {
                        subscriptionStore.updateSubscriptionParam({
                            param: 'point_name', value: record.attributes.name
                        })  
                    }
                }
            })
        },

        $_deliveryContainer_loadDeliveries () {
            shipmentZonesStore.updateAvailableShipmentZones([])
            shipmentZonesStore.selectShipmentZoneIndex(null)

            subscriptionStore.updateShipmentDay(null)
            subscriptionStore.updateShipmentZone(null)

            var src = this.subscriptionStore.subscriptionParams
            var params = {
                zip_code: src.zip_code,
                country: src.country,
                city: src.city
            }

            if (!params.city) return

                var dm = new ShipmentZonesApi()
                return dm.get(params)

            .then(response => {
                return shipmentZonesStore.updateAvailableShipmentZones(new ShipmentZones({ src: response.body.data.resources }), 1)
            })

            .then(response => {
                return this.$_deliveryContainer_loadCurrentDelivery()
            })

            .then(response => {
                return this.$_deliveryContainer_findCurrentDelivery()
            })

            .catch(response => {
                console.log(response)
            })
        },
        $_deliveryContainer_loadSubscriptionDelivery () {
            return deliveryStore.getDelivery({ 
                target_type: 'subscription', 
                target_id: this.user.subscription.id,
                include: 'timeRanges,address,shipment_zone.courier'
            })
        },
        $_deliveryContainer_loadCurrentDelivery () {
            return deliveryStore.getDelivery({ 
                target_type: 'order', 
                target_id: this.orderStore.order.id,
                include: 'timeRanges,address,shipment_zone.courier'
            })
        },

        $_deliveryContainer_findCurrentDelivery () {
            // shipmentZonesStore.selectShipmentZoneIndex(0)

            if (this.delivery) {
                subscriptionStore.updateShipmentDay(this.delivery.shipment_day)
                subscriptionStore.updateShipmentZone(this.delivery.shipment_zone_id)
            }

            if (subscriptionStore.state.shipment_day) {
            }

            var delivery = this.shipmentZonesStore.shipmentZones.available[0]

            if (this.delivery) {
                delivery = JSON.parse(JSON.stringify(delivery))
                delivery.shipment_day = this.delivery.shipment_day
            }
            this.$_deliveryContainer_selectDelivery(delivery)
        },

        $_deliveryContainer_selectDelivery (delivery) {
            if (!delivery) return

            orderStore.updateOrderParam({ param: 'shipment_zone_id', value: delivery.zone_id })
            orderStore.updateOrderParam({ param: 'shipment_day', value: delivery.shipment_day })

            subscriptionStore.updateShipmentDay(delivery.shipment_day)
            subscriptionStore.updateShipmentZone(delivery.zone_id)
            subscriptionStore.updateShipmentCourier(delivery.courier.name)

            subscriptionStore.updateSubscriptionParam({ param: 'province', value: delivery.province })
        }
    }
}
